import React, { useEffect, useState, useReducer, useRef } from 'react'
import { createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, Switch, FormGroup } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Loader from "react-loader-spinner";
import editIcon from '../../assets/1@3x.png';
import api from "../api";
import { format } from 'date-fns';
import MuiAlert from '@material-ui/lab/Alert';
import CloseImage from '../../assets/ic_close.png';
import { TramRounded } from '@material-ui/icons';
import icCircle from '../../assets/circle.png';
import icSeru from '../../assets/ic_exclamation.png';
import PrintIcon from '@material-ui/icons/Print';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ComponentGC } from '../Transaksi/ComponentGC';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

const pageStyle = `{size: 3.075in 10.25in}`;


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function GeneralConcenst(props) {
    const componentGC = useRef()
    const [dataTable, setDataTable] = useState([])
    const [dataFilter, setDataFilter] = useState(null)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [dataCount, setDataCount] = useState(10)
    const [validFrom, setValidFrom] = useState(null)
    const [validTo, setValidTo] = useState(null)
    const [detailID, setDetailID] = useState(null)
    const [tanggal, setTanggal] = useState(null)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataContent, setDataContent] = useState(null)

    useEffect(() => {
        props.setShowNotif(true)
        getDataTable()
        setValidFrom(new Date())
        setValidTo(new Date())
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDataTable = (a, b) => {
        api.create().getListGeneralConcents().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = []
                        response.data.data.map((item, index) => {
                            data.push([
                                index + 1,
                                item.user_name,
                                item.patient_name,
                                item.patient_date_of_birth,
                                item.patient_gender === "L" ? "Laki-Laki" : "Perempuan",
                                item.patient_identity_no,
                                item.id
                            ])
                        })
                        setDataTable(data)
                        setLoading(false)
                    } else {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("warning")
                        setLoading(false)

                    }
                }
            }
        })
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const updateDateRange = (a, b) => {
        setLoading(true)
        console.log(a, b);
        getDataTable(a, b)
        // const c = dataTable.filter((item) => {
        //     return Number(format(new Date(item[3]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[3]), 'yyyyMMdd')) <= Number(b)
        // });
        // setDataFilter(c)
        forceUpdate()
    }

    const printDocument = ({ rowData }) => {
        console.log(rowData);
        api.create().getDetailMonitoringGC(rowData[6]).then(response => {
            console.log(response);
            if (response.data) {
                let data = response.data.data
                if (response.data.status === true) {
                    setDataContent(data.details_in_html)
                }
            }
        })
    }

    const columns = [
        {
            name: "No",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            label: "Nama Pemilik Akun",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Nama Pasien",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Tanggal Lahir",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Jenis Kelamin",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "No. KTP",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "Aksi",
            options: {
                filter: false,
                sort: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, backgroundColor: 'white', }}>
                        <Typography style={{ fontWeight: 600 }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, backgroundColor: 'white', }}>
                //         <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div>
                            <ReactToPrint
                                pageStyle={pageStyle}
                                trigger={() => {
                                    return (
                                        <div style={{ display: 'flex' }}>
                                            <LightTooltip title={"Cetak"} arrow>
                                                <button
                                                    onClick={() => printDocument(tableMeta)}
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        fontSize: 20,
                                                        outline: 'none',
                                                        borderColor: 'transparent'
                                                    }}>
                                                    <PrintIcon style={{ color: '#519d6d' }} />
                                                </button>
                                            </LightTooltip>
                                        </div>
                                    )
                                }}
                                content={() => componentGC.current}
                            >
                            </ReactToPrint>

                            <div style={{ display: 'none' }}>
                                <ComponentGC
                                    dataContent={dataContent}
                                    ref={componentGC}
                                />
                            </div>
                        </div>


                    )
                }
            }
        },
        {
            name: "",
            label: "",
            options: {
                display: false,
                filter: false
            }
        }
    ];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: true,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',

    };

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative', height: props.height - 100, overflow: 'auto' }}>
            {loading && (loadingComponent)}
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ minHeight: 600, width: props.width - (props.open === true ? 370 : 120) }}>
                {dataFilter === null ?
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            columns={columns}
                            data={dataTable}
                            options={options}
                        />
                    </MuiThemeProvider>
                    :
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            columns={columns}
                            data={dataFilter}
                            options={options}
                        />
                    </MuiThemeProvider>
                }
            </div>
        </div>
    )
}